<!-- 院长端 -->
<template>
  <div class="no-data">
    <img src="./../../assets/img/no_data.jpg" alt="" srcset="" />
    <div>暂无内容哦</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.no-data {
  height: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #262626;
  font-size: 14px;
  margin-top: 40px;
}
</style>
